import { DocumentStagesData } from "@/hooks/useDocumentStages"

export const isDocumentRelevant = (stagesData: DocumentStagesData): boolean => {
	if (stagesData.stage3?.status !== "completed") return false

	return stagesData.stage3.is_relevant
}
